import { useState } from 'react';
import Breadcrumb from '@/components/base/Breadcrumb';
import { Link } from 'react-router-dom';
import RelatedPages from '@/components/base/RelatedPages';

const formulas = [
  {
    id: 'crystal-bright',
    icon: 'ri-eye-line',
    title: '晶亮配方',
    tag: '眼部保健',
    desc: '葉黃素、玉米黃素複方，針對長時間用眼族群，守護視力健康。',
    dosages: ['軟膠囊', '錠劑', '粉劑'],
    targets: ['上班族', '學生族', '銀髮族'],
    color: 'bg-green-50 border-green-200',
    imgSrc: 'https://readdy.ai/api/search-image?query=eye%20health%20supplement%20capsules%20with%20marigold%20flowers%20lutein%20zeaxanthin%20ingredients%20on%20clean%20white%20surface%2C%20minimal%20health%20product%20photography&width=400&height=260&seq=hf-01&orientation=landscape',
  },
  {
    id: 'womens',
    icon: 'ri-women-line',
    title: '女性專屬',
    tag: '女性保健',
    desc: '私密健康、更年期調養、養顏補血，全面關注女性各階段需求。',
    dosages: ['膠囊', '錠劑', '果凍條'],
    targets: ['育齡女性', '更年期女性', '養顏族群'],
    color: 'bg-rose-50 border-rose-200',
    imgSrc: 'https://readdy.ai/api/search-image?query=womens%20health%20supplement%20products%20with%20rose%20flower%20petals%20and%20botanical%20ingredients%2C%20feminine%20health%20care%20products%20flat%20lay%20on%20white%20background%2C%20natural%20pink%20tones&width=400&height=260&seq=hf-02&orientation=landscape',
  },
  {
    id: 'mens',
    icon: 'ri-men-line',
    title: '男性專屬',
    tag: '男性活力',
    desc: '活力補充、護攝護腺、強化體能，專為現代男性設計的保健配方。',
    dosages: ['膠囊', '錠劑', '粉劑'],
    targets: ['中壯年男性', '運動族', '工作壓力族'],
    color: 'bg-sky-50 border-sky-200',
    imgSrc: 'https://readdy.ai/api/search-image?query=mens%20health%20supplement%20capsules%20with%20zinc%20selenium%20saw%20palmetto%20botanical%20ingredients%20on%20clean%20white%20surface%2C%20masculine%20health%20product%20flat%20lay&width=400&height=260&seq=hf-03&orientation=landscape',
  },
  {
    id: 'gut',
    icon: 'ri-seedling-line',
    title: '腸道健康',
    tag: '消化保健',
    desc: '多元益生菌複方搭配膳食纖維，促進腸道菌相平衡，改善消化舒適。',
    dosages: ['膠囊', '粉包', '錠劑'],
    targets: ['全年齡層', '消化不適族', '低纖維飲食族'],
    color: 'bg-green-50 border-green-200',
    imgSrc: 'https://readdy.ai/api/search-image?query=probiotic%20gut%20health%20supplement%20powder%20capsules%20with%20fermented%20ingredients%20prebiotics%20fiber%20on%20clean%20white%20surface%2C%20health%20food%20photography%20minimal&width=400&height=260&seq=hf-04&orientation=landscape',
  },
  {
    id: 'hydration',
    icon: 'ri-drop-line',
    title: '水潤美顏',
    tag: '美容保養',
    desc: '玻尿酸、膠原蛋白、維生素 C 三效複方，由內而外維持肌膚水潤光澤。',
    dosages: ['粉包', '果凍條', '膠囊'],
    targets: ['美容族', '乾性肌膚', '熟齡保養'],
    color: 'bg-amber-50 border-amber-200',
    imgSrc: 'https://readdy.ai/api/search-image?query=collagen%20hyaluronic%20acid%20beauty%20supplement%20powder%20sachets%20with%20peach%20and%20rose%20on%20white%20surface%2C%20feminine%20health%20skincare%20product%20photography&width=400&height=260&seq=hf-05&orientation=landscape',
  },
  {
    id: 'hair',
    icon: 'ri-scissors-line',
    title: '頂上煩惱',
    tag: '頭髮保健',
    desc: '鋸棕櫚、生物素、胱氨酸複方，針對脫髮困擾提供全方位養護。',
    dosages: ['膠囊', '錠劑'],
    targets: ['脫髮困擾族', '中壯年男女', '產後媽媽'],
    color: 'bg-orange-50 border-orange-200',
    imgSrc: 'https://readdy.ai/api/search-image?query=hair%20health%20supplement%20biotin%20capsules%20with%20rosemary%20herbs%20saw%20palmetto%20on%20white%20surface%2C%20hair%20care%20product%20minimal%20photography%20warm%20natural%20tones&width=400&height=260&seq=hf-06&orientation=landscape',
  },
  {
    id: 'baby',
    icon: 'ri-parent-line',
    title: '寶寶配方',
    tag: '嬰幼兒',
    desc: '嬰幼兒專屬安心配方，DHA、益生菌、維生素 D，溫和添加嚴格把關。',
    dosages: ['粉劑', '滴劑'],
    targets: ['0-3 歲嬰幼兒', '哺乳媽媽', '家長選購'],
    color: 'bg-yellow-50 border-yellow-200',
    imgSrc: 'https://readdy.ai/api/search-image?query=baby%20infant%20supplement%20powder%20formula%20DHA%20omega3%20vitamins%20on%20clean%20white%20surface%2C%20gentle%20soft%20pastel%20tones%20health%20product%20photography%20for%20infants&width=400&height=260&seq=hf-07&orientation=landscape',
  },
  {
    id: 'pets',
    icon: 'ri-heart-line',
    title: '毛孩專屬',
    tag: '寵物保健',
    desc: '針對貓狗設計的保健配方，關節護理、腸道健康、皮毛光澤三大方向。',
    dosages: ['粉劑', '錠劑', '零食劑型'],
    targets: ['貓主人', '狗主人', '老齡寵物'],
    color: 'bg-brown-50 border-amber-200',
    imgSrc: 'https://readdy.ai/api/search-image?query=pet%20health%20supplement%20products%20for%20dogs%20and%20cats%2C%20natural%20ingredient%20treats%20powder%20on%20white%20surface%2C%20veterinary%20supplement%20product%20minimal%20photography%20warm%20tones&width=400&height=260&seq=hf-08&orientation=landscape',
  },
  {
    id: 'fitness',
    icon: 'ri-run-line',
    title: '健力補充',
    tag: '運動健身',
    desc: '乳清蛋白、BCAA、肌酸複方，幫助運動後快速恢復與肌肉維護。',
    dosages: ['粉劑', '膠囊', '錠劑'],
    targets: ['健身族', '運動員', '體能維持族'],
    color: 'bg-emerald-50 border-emerald-200',
    imgSrc: 'https://readdy.ai/api/search-image?query=sports%20fitness%20supplement%20protein%20powder%20capsules%20with%20green%20leaf%20botanical%20ingredients%20on%20clean%20white%20surface%2C%20athletic%20health%20product%20flat%20lay%20photography&width=400&height=260&seq=hf-09&orientation=landscape',
  },
  {
    id: 'sleep',
    icon: 'ri-moon-line',
    title: '舒眠減壓',
    tag: '睡眠輔助',
    desc: '色胺酸、GABA、茶胺酸三效舒眠複方，協助改善入睡困難與睡眠品質。',
    dosages: ['膠囊', '錠劑', '果凍條'],
    targets: ['失眠族', '壓力大族', '輪班工作者'],
    color: 'bg-indigo-50 border-indigo-200',
    imgSrc: 'https://readdy.ai/api/search-image?query=sleep%20wellness%20supplement%20chamomile%20lavender%20valerian%20melatonin%20products%20on%20white%20surface%2C%20calming%20nighttime%20health%20product%20photography%20soft%20purple%20tones&width=400&height=260&seq=hf-10&orientation=landscape',
  },
  {
    id: 'kids',
    icon: 'ri-user-heart-line',
    title: '兒童成長',
    tag: '兒童保健',
    desc: '鈣質、維生素 D3、益智 DHA，支持兒童骨骼發育與學習力提升。',
    dosages: ['軟糖', '粉劑', '錠劑'],
    targets: ['學齡兒童', '挑食小朋友', '家長選購'],
    color: 'bg-lime-50 border-lime-200',
    imgSrc: 'https://readdy.ai/api/search-image?query=children%20health%20supplement%20gummy%20vitamins%20calcium%20DHA%20colorful%20products%20on%20white%20surface%2C%20cute%20playful%20health%20product%20photography%20bright%20cheerful%20tones&width=400&height=260&seq=hf-11&orientation=landscape',
  },
  {
    id: 'slimming',
    icon: 'ri-scales-2-line',
    title: '輕盈窈窕',
    tag: '體重管理',
    desc: '藤黃果、白腎豆、辣椒素複方，搭配膳食纖維，協助體重管理與輕盈體態。',
    dosages: ['膠囊', '粉包'],
    targets: ['體重管理族', '低卡飲食族', '瘦身計畫族'],
    color: 'bg-teal-50 border-teal-200',
    imgSrc: 'https://readdy.ai/api/search-image?query=weight%20management%20diet%20supplement%20with%20garcinia%20cambogia%20green%20tea%20extract%20capsules%20on%20white%20surface%2C%20slim%20figure%20health%20product%20minimal%20clean%20photography&width=400&height=260&seq=hf-12&orientation=landscape',
  },
];

export default function HomeHotFormulasContent() {
  const [expandedId, setExpandedId] = useState<string | null>(null);

  return (
    <>
      {/* Hero */}
      <section className="relative pt-20 min-h-[380px] md:min-h-[440px] flex items-end overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=colorful%20variety%20of%20health%20supplement%20products%20capsules%20powders%20gummies%20arranged%20beautifully%20on%20clean%20white%20marble%20surface%2C%20best%20selling%20nutraceutical%20product%20collection%20flat%20lay%20photography&width=1920&height=440&seq=hhf-hero-bg-01&orientation=landscape"
            alt="熱銷配方背景"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-[#0d2310]/90 via-[#0d2310]/60 to-[#0d2310]/20" />
        </div>
        <div className="relative z-10 w-full max-w-screen-xl mx-auto px-6 lg:px-10 pb-14 pt-28">
          <div className="max-w-2xl">
            <Breadcrumb
              items={[
                { label: '首頁', href: '/' },
                { label: '熱銷配方' },
              ]}
              className="mb-4 text-gray-300"
            />
            <span className="inline-block bg-[#4CAF50]/25 border border-[#4CAF50]/50 text-green-300 text-[0.875rem] font-medium px-4 py-1.5 rounded-full mb-5">
              首頁 · 熱銷配方
            </span>
            <h1 className="text-white font-bold text-[2.25rem] md:text-[2.875rem] leading-tight mb-4">
              熱銷配方
            </h1>
            <p className="text-gray-200 text-[1.0625rem] leading-[1.75] max-w-xl">
              依照市場需求、族群特性與通路定位，協助品牌選擇適合的保健配方方向。
            </p>
          </div>
        </div>
      </section>

      {/* Intro bar */}
      <section className="bg-white border-b border-gray-100 py-5">
        <div className="max-w-screen-xl mx-auto px-6 lg:px-10">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {[
              { icon: 'ri-medal-line', text: '市場暢銷驗證' },
              { icon: 'ri-flask-line', text: '研發配方多元' },
              { icon: 'ri-leaf-line', text: '天然原料嚴選' },
              { icon: 'ri-settings-line', text: '客製調整彈性' },
            ].map((item) => (
              <div key={item.text} className="flex items-center gap-3">
                <div className="w-9 h-9 flex items-center justify-center bg-green-50 rounded-lg border border-green-100 flex-shrink-0">
                  <i className={`${item.icon} text-[#4CAF50] text-base`} />
                </div>
                <span className="text-[#1a2e1a] text-[0.875rem] font-medium">{item.text}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Formula cards */}
      <section className="py-20 bg-[#f7faf7]">
        <div className="max-w-screen-xl mx-auto px-6 lg:px-10">
          <div className="text-center mb-14">
            <span className="inline-block bg-green-50 text-[#4CAF50] text-[0.875rem] font-medium px-4 py-1.5 rounded-full mb-4 border border-green-200">
              12 大熱銷方向
            </span>
            <h2 className="text-[#1a2e1a] font-bold text-[1.75rem] md:text-[2.125rem] mb-4">
              市場最受歡迎的配方選擇
            </h2>
            <p className="text-gray-500 text-[1.0625rem] leading-[1.75] max-w-2xl mx-auto">
              每個配方方向均來自市場需求分析，搭配天然成分研發，讓您輕鬆切入熱門賽道
            </p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
            {formulas.map((f) => (
              <div
                key={f.id}
                className="bg-white rounded-2xl border border-gray-100 overflow-hidden hover:border-green-200 hover:-translate-y-1 transition-all duration-300"
              >
                {/* Image */}
                <div className="w-full overflow-hidden" style={{ height: '220px' }}>
                  <img
                    src={f.imgSrc}
                    alt={f.title}
                    className="w-full h-full object-cover object-top transition-transform duration-500 hover:scale-105"
                  />
                </div>
                {/* Content */}
                <div className="p-5">
                  <div className="flex items-center justify-between mb-3">
                    <div className="flex items-center gap-2">
                      <div className="w-8 h-8 flex items-center justify-center bg-green-50 rounded-lg border border-green-100">
                        <i className={`${f.icon} text-[#4CAF50] text-sm`} />
                      </div>
                      <h3 className="text-[#1a2e1a] font-bold text-[1rem]">{f.title}</h3>
                    </div>
                    <span className="text-[0.6875rem] text-[#4CAF50] bg-green-50 border border-green-100 px-2 py-0.5 rounded-full whitespace-nowrap">{f.tag}</span>
                  </div>
                  <p className="text-gray-500 text-[0.875rem] leading-[1.7] mb-4">{f.desc}</p>
                  {/* Dosage tags */}
                  <div className="flex flex-wrap gap-1.5 mb-4">
                    {f.dosages.map((d) => (
                      <span key={d} className="text-[0.75rem] text-gray-500 bg-gray-50 border border-gray-200 px-2 py-0.5 rounded-full">{d}</span>
                    ))}
                  </div>
                  {/* Expand */}
                  <button
                    onClick={() => setExpandedId(expandedId === f.id ? null : f.id)}
                    className="w-full flex items-center justify-between text-[0.875rem] text-[#4CAF50] font-medium cursor-pointer hover:text-[#43a047] transition-colors py-1"
                  >
                    <span>{expandedId === f.id ? '收起詳情' : '了解更多'}</span>
                    <i className={`ri-arrow-down-s-line text-base transition-transform duration-200 ${expandedId === f.id ? 'rotate-180' : ''}`} />
                  </button>
                  {expandedId === f.id && (
                    <div className="pt-3 border-t border-gray-100 mt-3">
                      <div className="text-[0.8125rem] text-gray-500 mb-2 font-medium">適合族群：</div>
                      <div className="flex flex-wrap gap-1.5 mb-4">
                        {f.targets.map((t) => (
                          <span key={t} className="text-[0.75rem] text-gray-600 bg-[#f7faf7] border border-gray-200 px-2 py-0.5 rounded-full">{t}</span>
                        ))}
                      </div>
                      <Link
                        to="/services/hot-formulas"
                        className="w-full flex items-center justify-center gap-2 bg-[#4CAF50] hover:bg-[#43a047] text-white text-[0.875rem] font-semibold py-2.5 rounded-xl transition-all duration-300 cursor-pointer"
                      >
                        查看詳細配方
                        <i className="ri-arrow-right-line text-sm" />
                      </Link>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Process reminder */}
      <section className="py-16 bg-white">
        <div className="max-w-screen-xl mx-auto px-6 lg:px-10">
          <div className="bg-[#f7faf7] rounded-2xl p-8 md:p-12 border border-green-100">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
              <div>
                <span className="inline-block bg-green-50 text-[#4CAF50] text-[0.875rem] font-medium px-4 py-1.5 rounded-full mb-5 border border-green-200">
                  配方客製說明
                </span>
                <h3 className="text-[#1a2e1a] font-bold text-[1.5rem] md:text-[1.875rem] mb-4">
                  以上為參考方向，可全面客製調整
                </h3>
                <p className="text-gray-500 text-[1.0625rem] leading-[1.85]">
                  每個品牌的市場定位不同，康永生技提供配方客製化服務，依照您的品牌策略、目標族群與預算範圍，量身規劃最適合的配方組合。
                </p>
              </div>
              <div className="space-y-3">
                {[
                  { icon: 'ri-check-line', text: '原料替換與添加量調整' },
                  { icon: 'ri-check-line', text: '劑型依需求彈性切換' },
                  { icon: 'ri-check-line', text: '符合特定通路規格需求' },
                  { icon: 'ri-check-line', text: '法規合規事前審查確認' },
                ].map((item) => (
                  <div key={item.text} className="flex items-center gap-3">
                    <div className="w-6 h-6 flex items-center justify-center bg-[#4CAF50] rounded-full flex-shrink-0">
                      <i className={`${item.icon} text-white text-xs`} />
                    </div>
                    <span className="text-[#1a2e1a] text-[1rem]">{item.text}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-16 bg-[#f7faf7]">
        <div className="max-w-screen-xl mx-auto px-6 lg:px-10 text-center">
          <h2 className="text-[#1a2e1a] font-bold text-[1.75rem] md:text-[2.125rem] leading-tight mb-4">
            找到您的配方方向了嗎？
          </h2>
          <p className="text-gray-500 text-[1.0625rem] leading-[1.75] max-w-xl mx-auto mb-8">
            立即與康永生技的配方顧問聯繫，讓我們協助您打造市場上最受歡迎的保健品牌。
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <Link
              to="/contact/form"
              className="whitespace-nowrap inline-flex items-center gap-2 bg-[#4CAF50] hover:bg-[#43a047] text-white font-bold text-[1.0625rem] px-10 py-4 rounded-full transition-all duration-300 cursor-pointer"
            >
              洽詢熱銷配方
              <i className="ri-arrow-right-line" />
            </Link>
            <Link
              to="/services/hot-formulas"
              className="whitespace-nowrap inline-flex items-center gap-2 border border-[#4CAF50] text-[#4CAF50] hover:bg-[#4CAF50] hover:text-white font-semibold text-[1.0625rem] px-10 py-4 rounded-full transition-all duration-300 cursor-pointer"
            >
              查看更多配方詳情
            </Link>
          </div>
        </div>
      </section>
      <RelatedPages items={[
        { title: '熱销配方（代工服務）', desc: '查看康永 17 大熱销配方詳細說明與勑型選擇。', href: '/services/hot-formulas' },
        { title: '各類劑型', desc: '膨囊、錢劑、粉劑、果凍條…選擇適合品牌定位的劑型。', href: '/services/dosage-forms' },
        { title: '洽詢配方開發', desc: '填寫諮詢表單，讓康永研發团隊協助您打造熱销品。', href: '/contact/form' },
      ]} />
    </>
  );
}
